import { Alert, Button, Checkbox, Form, Input, InputNumber } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { normalizeArrayFields } from 'src/util/Util'
import nodeApi from './NodeApi'

const FormItem = Form.Item;

interface Props {
}

const NodeEdit: React.FC<Props> = () => {

    const [form] = useForm()

    const [error, setError] = useState()

    const history = useHistory()

    const { id } = useParams<{ id?: string }>()

    const handleSubmit = () => {
        normalizeArrayFields(['clusterId'], form)
        form.validateFields().then(values => {
            nodeApi
                .edit(Number.parseInt(id ?? '-1'), { ...values })
                .then(history.goBack)
                .catch(err => {
                    setError(err.error)
                })
        })
    }

    useEffect(() => {
        nodeApi
            .view(Number.parseInt(id ?? '-1'))
            .then(itemResponseNodeBeanObject => {
                const bean = itemResponseNodeBeanObject.data
                if (!bean) {
                    return
                }
                form.setFieldsValue(bean)
            })
            .catch(err => {
                setError(err.error)
            })

    }, [])

    return (
        <Form
            style={{
                maxWidth: '1000px'
            }}
            onFinish={handleSubmit}
            form={form}
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
        >
            {error ? <Alert message={error} type="error" /> : null}
            <FormItem
                name="name"
                rules={[
                    {
                        required: true,
                        message: 'Please input Node name'
                    },
                    {
                        max: 255,
                        message: 'Name cannot be longer that 255 characters'
                    }
                ]}
                label="Name"
                tooltip={'Name of the node'}
            >
                <Input />
            </FormItem>
            <FormItem
                name="clusterId"
                rules={[{ required: true, message: 'Please input cluster ID list' }]}
                label="Cluster ID list"
                tooltip={'Comma separated cluster ID list'}
            >
                <Input />
            </FormItem>
            <FormItem
                name="walletId"
                rules={[
                    {
                        required: true,
                        message: 'Please input Wallet ID'
                    },
                    {
                        pattern: new RegExp('^\\s*0x\\S*\\s*$'),
                        message: 'Wallet ID should start with 0x'
                    },
                    {
                        max: 255,
                        message: 'Wallet ID cannot be longer that 255 characters'
                    }
                ]}
                label="WalletId"
                tooltip={'WalletId of node'}
            >
                <Input />
            </FormItem>
            <FormItem
                name="ip"
                rules={[
                    {
                        required: true,
                        message: 'Please input ip address'
                    },
                    {
                        max: 255,
                        message: 'Name cannot be longer that 255 characters'
                    }
                ]}
                label="Ip address"
                tooltip={'Ip address of node'}
            >
                <Input />
            </FormItem>
            <FormItem
                name="port"
                rules={[
                    {
                        required: true,
                        message: 'Please input port'
                    },
                    {
                        type: 'integer',
                        min: 1,
                        max: 999999,
                        message: 'Please input a valid number',
                    }
                ]}
                label="Port"
                tooltip={'Port of node'}
            >
                <InputNumber min={1} max={999999} />
            </FormItem>
            <FormItem
                name="active"
                label="Active"
                valuePropName="checked"
                tooltip={'If true than the requests will be sent to node'}
            >
                <Checkbox />
            </FormItem>
            <FormItem
                wrapperCol={{
                    offset: 11, span: 6
                }}>
                <Button style={{
                    width: '45%',
                    margin: '0 2%'
                }} type="primary" htmlType="submit">Save</Button>
                <Button style={{
                    width: '45%',
                    margin: '0 2%'
                }} type="primary" danger htmlType="button" onClick={history.goBack}>Cancel</Button>
            </FormItem>
        </Form>
    )
}

export default NodeEdit;
